import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LuCheck, LuX } from "react-icons/lu";
import { notify } from "../../../common/Toast";
import { updateLastPoNum } from "../../../redux/action/requestsAction/RequestsAction";
import { LuClipboardList, LuHash, LuPencilLine } from "react-icons/lu";

export default function RequestsStats({ numRequests }) {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const { lastPoNum, poNumLoading } = useSelector((state) => state.request);

  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(lastPoNum);

  useEffect(() => {
    setDraft(lastPoNum);
  }, [lastPoNum]);

  const handleSave = async () => {
    const res = await dispatch(updateLastPoNum(Number(draft)));
    if (res.success) {
      notify.success("Successful PO Number Change", "Last PO Number updated successfully.");
      setEditing(false);
    } else {
      notify.error("Failed to update last PO Number", res.error);
    }
  };

  return (
    <div className="mx-3 my-4 grid grid-cols-1 gap-3 sm:mx-4 sm:grid-cols-2">
      {/* Total requests */}
      <div className="group relative overflow-hidden rounded-xl border border-slate-200 bg-white p-4 shadow-sm transition hover:shadow-md">
        <div className="absolute inset-y-0 left-0 w-1 bg-brand-gradient" />
        <div className="flex items-center gap-4 pl-2">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-brand-50 text-brand-600">
            <LuClipboardList size={22} />
          </div>
          <div className="min-w-0">
            <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">
              Total Requests
            </p>
            <p className="text-2xl font-extrabold leading-tight text-slate-900">{numRequests}</p>
          </div>
        </div>
      </div>

      {/* Last used PO number */}
      <div className="group relative overflow-hidden rounded-xl border border-slate-200 bg-white p-4 shadow-sm transition hover:shadow-md">
        <div className="absolute inset-y-0 left-0 w-1 bg-teal-500" />
        <div className="flex items-center justify-between gap-4 pl-2">
          <div className="flex min-w-0 items-center gap-4">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-teal-50 text-teal-600">
              <LuHash size={22} />
            </div>
            <div className="min-w-0">
              <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">
                Last Used PO Number
              </p>

              {editing ? (
                <div className="mt-1 flex items-center gap-1.5">
                  <input
                    type="number"
                    min={0}
                    autoFocus
                    value={draft}
                    onChange={(e) => setDraft(e.target.value)}
                    className="w-24 rounded-md border border-slate-200 px-2 py-1 text-[14px] font-semibold outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20"
                  />
                  <button
                    onClick={handleSave}
                    disabled={poNumLoading}
                    className="flex h-7 w-7 items-center justify-center rounded-md bg-teal-600 text-white transition hover:bg-teal-700 disabled:opacity-60"
                    title="Save"
                  >
                    <LuCheck size={13} />
                  </button>
                  <button
                    onClick={() => {
                      setDraft(lastPoNum);
                      setEditing(false);
                    }}
                    className="flex h-7 w-7 items-center justify-center rounded-md border border-slate-200 text-slate-500 transition hover:bg-slate-50"
                    title="Cancel"
                  >
                    <LuX size={13} />
                  </button>
                </div>
              ) : (
                <p className="text-2xl font-extrabold leading-tight text-slate-900">{lastPoNum}</p>
              )}
            </div>
          </div>

          {user?.admin && !editing && (
            <button
              onClick={() => setEditing(true)}
              className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-slate-400 opacity-0 transition group-hover:opacity-100 hover:bg-slate-100 hover:text-slate-600"
              title="Edit PO number"
            >
              <LuPencilLine size={15} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}